import React from 'react';
import bemCn from 'bem-cn';
import { RouteFormatter } from '../../routes';
import SniffErrorImg from '../../assets/img/sniff-error.png';
import SniffButton from '../../components/sniff-button';
import PictureSet from '../../components/picture-set';
import './style.scss';

const b = bemCn('not-found');

const NotFound = () => {
    const from = window.location.href;

    return (
        <div className={b()}>
            <div className="text-center">
                <PictureSet imgs={SniffErrorImg} className={b('img')} noLoad />
            </div>
            <div className="mt-3 snif-m1 snif-semibold text-center">Woof! Page not found</div>
            <div className="mt-2 snif-p text-deep text-center">
                The page you're looking for does not exist. If you believe something is broken, please{' '}
                <a className={b('report')} href={RouteFormatter.contactSupport(null, { query: { from } })}>
                    report a problem
                </a>
                .
            </div>
            <div className="mt-4 text-center">
                <a href={RouteFormatter.home()}>
                    <SniffButton size="lg">Go to homepage</SniffButton>
                </a>
            </div>
        </div>
    );
};

export default NotFound;
